import CSVPreviewSection from '../CSVPreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function AllTasksEvACSVPreviewColumnStrategy() {}

AllTasksEvACSVPreviewColumnStrategy.prototype = new CSVPreviewSection()

AllTasksEvACSVPreviewColumnStrategy.prototype.getNumOfDataColumns = function() {
    return 2 // total for not est, total for est
}

AllTasksEvACSVPreviewColumnStrategy.prototype.addDataColumns = function(row) {
    this.addCell(row, this.message("report.budgeted_vs_actual.time_for_not_estimated_tasks"))
    this.addCell(row, this.message("report.budgeted_vs_actual.time_for_estimated_tasks"))
}

AllTasksEvACSVPreviewColumnStrategy.prototype.addCellValues = function(row, groupingLevel) {
    if (groupingLevel === ReportGroupingLevel.USER || groupingLevel === ReportGroupingLevel.TASK)
        this.addCell(row, "")
    else
        this.addTimeValueCell(row)

    this.addTimeValueCell(row)
}




// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/eva/AllTasksEvACSVPreviewColumnStrategy.js